module.exports = __webpack_public_path__ + "44405cd1916614142cb6af8d3c2ebd0b.svg";